import { AppCommands } from "../AppCommands";
import { CommandList } from "../CommandList";
import { ModifierKeys } from "../ModifierKey";

export class GodotCommands extends AppCommands
{
  
  defaultCommands:CommandList;
  rokojoriCommands:CommandList;
  customCommands:CommandList;

  constructor()
  {
    super();

    this.defaultCommands  = new CommandList( "default" );
    this.rokojoriCommands = new CommandList( "rokojori", "default" );
    this.customCommands   = new CommandList( "custom", "default" );  

    this.profileCommandLists = 
    [
      this.defaultCommands,
      this.rokojoriCommands,
      this.customCommands
    ];

    this.createCommands();
  }

  createCommands()
  {
    this.defaultCommands.addKeyCommand( "Build Solution", "", "B", ModifierKeys.Mod2 );
  }
}